<template>
  <div class="date-range-cmp">
    <template v-if="dateRangeExt === '0'">
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :class="['system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange" />
    </template>
    <template v-else-if="dateRangeExt === '1'">
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" class="system-form-item-fields" v-model="modulesItem.fieldValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :class="['system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange" />
    </template>
    <template v-else>
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :class="['system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange" />
    </template>
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
import dayjs from 'dayjs';
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const dateRangeExt = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
});
const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './date-range.less';
</style>
